<ng-container *ngIf="isShow">
  <div [class]="type + '-tape tape'">
    <app-icon *ngIf="type === typeMessageType.SYSTEM_ALERT" [icon]="icon.PUBLICATION_INSTABILITY" [color]="iconColor.DARK"></app-icon>
    <p *ngIf="type === typeMessageType.SYSTEM_ALERT" class="font-overflow-ellipsis-clamp">{{ message }}</p>
    <app-icon *ngIf="type === typeMessageType.SOCKET_INTERRUPTED" [icon]="icon.SOCKET_INTERRUPTED" [color]="iconColor.DARK"></app-icon>
    <p *ngIf="type === typeMessageType.SOCKET_INTERRUPTED" class="font-overflow-ellipsis-clamp">{{ message }}</p>
  </div>
</ng-container>
